import React, { Component } from 'react';
import { ReCaptcha } from "react-recaptcha-google";
import * as Constants from '../common/Constants';
import { connect } from 'react-redux';

class Captcha extends Component {

    _onLoadRecaptcha = () => {
        this.props.setCaptchaValue(false,'');
    };

    _onVerifyCallback = (recaptcha) => {
        if (recaptcha) {
            this.props.setCaptchaValue(true,recaptcha);
        }

    };

    _onExpiredCallback = () => {
        this.props.setCaptchaValue(false,'');
    };


    render() {
        return (
            window.recaptcha ? <ReCaptcha
                render="explicit"
                size="normal"
                sitekey={"6LdNAAwUAAAAALEhZyYgkqFtXUPKVhD5Fj2XaWUm"}
                onloadCallback={this._onLoadRecaptcha}
                verifyCallback={this._onVerifyCallback}
                expiredCallback={this._onExpiredCallback}
                data-theme="dark"
                hl="en"
            /> : null
        );
    }

}

const mapDispatchToProps = dispatch => {
    return {
        setCaptchaValue: (captchaValue,captchaResponse) => dispatch({
            type: Constants.CAPTCHA_VALIDATE,
            payload: {
                captchaValue: captchaValue,
                captchaResponse : captchaResponse
            }
        })
    }
}


export default connect(null, mapDispatchToProps)(Captcha);
